import React, {useEffect, useState} from "react";
import clsx from "clsx";
import {useStyles} from "./ValetInventoryDetailDrawer.styles";
import {
  Typography,
  Divider,
  Button,
  Drawer,
} from "@material-ui/core";
import TicketDetails from "./TicketDetails/TicketDetails";
import HistoryComponent from "./HistoryComponent/HistoryComponent";
import { useSelector } from "react-redux";

const ValetInventoryDetailDrawer = ({credential, open, onClose, isAutoRefresh}) => {
  const classes = useStyles();
  const [refreshValetTicketDetails, setRefreshValetTicketDetails] = useState(false);
  const credentialId = credential?.credentialId || credential?.credentialID ;
  const [previousCredential, setPreviousCredential] = useState(credential)
  const requests = useSelector((state)=> (state?.requestMonitor?.requests));
  
  //Persisting the credential details to compare with updated credential while any re-rendering happens
   useEffect(() => {
     setPreviousCredential(credential);
   }, [credential, setPreviousCredential]);

   //Re-render the child component whenever there is details updated in the respective ticket opened in slide-out
   //isAutoRefresh - rerendering logic gets applied only when isAutoRefresh is true
   useEffect(() => {
     if (previousCredential && isAutoRefresh) {
       const currentCredential = requests.find(
         (item) => item.credentialID === previousCredential.credentialID
       );
       if (JSON.stringify(currentCredential) !== JSON.stringify(previousCredential)) {
         setRefreshValetTicketDetails((prev) => !prev);
        setPreviousCredential(currentCredential);
       }
     }
  }, [requests, previousCredential]);

	return (
    <Drawer
      className={clsx("drawer", classes.drawer)}
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
      onClose={onClose}
    >
      <div className={classes.cssGridContainer}>
        <div className={classes.cssGrid}>
          <div>
            <Typography
              variant="h5"
              color="primary"
              component="h2"
              className={clsx(classes.title)}
            >
              Ticket Detail
            </Typography>
          </div>
          <Divider style={{marginBottom: 15}}></Divider>
          <div>
            <div className={clsx(classes.detailContainer)}>
                <TicketDetails credentialId={ credentialId } key={refreshValetTicketDetails} isAutoRefresh={isAutoRefresh}/>
            </div>
            <div style={{marginTop: "2rem"}}>
              <HistoryComponent credentialId={ credentialId } key={refreshValetTicketDetails}></HistoryComponent>
            </div>
          </div>
          <Divider></Divider>
          <div style={{paddingRight: "8px"}}>
          <Button
        style={{float: "right"}}
        data-id="closeBtn"
        name="close"
        variant="contained"
        onClick={onClose}
      >
        Close
      </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default ValetInventoryDetailDrawer;
